var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-news-slide"
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l(_vm.boards, function (board) {
    return _c('div', {
      key: board._id,
      staticClass: "swiper-slide",
      on: {
        "click": function ($event) {
          return _vm.openWindow(board.meta.href);
        }
      }
    }, [_c('div', {
      staticClass: "main-news-slide__con"
    }, [_c('div', {
      staticClass: "border rounded pa-20 px-md-36 py-md-50"
    }, [_c('div', {
      staticClass: "mb-20 mb-md-34"
    }, [_c('v-chip', {
      attrs: {
        "outlined": "",
        "color": "primary"
      }
    }, [_vm._v("NEWS")])], 1), _c('div', {
      staticClass: "mb-10 mb-md-12"
    }, [_c('div', {
      staticClass: "main-news-slide__tit font-size-18 font-size-lg-22 font-weight-bold"
    }, [_vm._v(_vm._s(board.subject))])]), _c('div', [_c('div', {
      staticClass: "main-news-slide__txt font-size-16 font-size-md-18 grey-7--text"
    }, [_vm._v(_vm._s(board.summary))])]), _c('div', {
      staticClass: "mt-20 mt-md-34"
    }, [_c('div', {
      staticClass: "font-size-14 font-size-md-16 grey-a--text"
    }, [_vm._v(_vm._s(board.createdAt.toDate()))])])]), _c('v-btn', {
      attrs: {
        "fab": "",
        "color": "primary"
      }
    }, [_c('i', {
      staticClass: "icon icon-arrow-right-white"
    })])], 1)]);
  }), 0)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }